import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/normal_laboratory',
  	  method: 'get',
        params
  	})
  }
 
  export function inventory(params) {
    return request({
      url: '/normal_laboratory/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/normal_laboratory/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/normal_laboratory',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/normal_laboratory/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/normal_laboratory/${id}`,
      method: 'delete',
    })
  }
